import { findScrollableParent, calcOffsetFromParent } from './utilFunctions';

export default (ids, reportHeight = false) => ({
	tabIndex: 0,
	scrollableParent: null,
	isMobileCollapseOpen: false,
	scrollOffsets: [],
	updateOffsets() {
		let thisobj = this;
		this.scrollOffsets = ids.map((id) =>
			calcOffsetFromParent(
				document.querySelector('#' + id),
				thisobj.scrollableParent
			)
		);
	},
	cache: {
		root: null,
	},
	updateTab() {
		let i = 0;
		const parentHeight = Math.min(
			this.scrollableParent.offsetHeight,
			window.innerHeight
		);
		while (
			i + 1 < ids.length &&
			document.querySelector('#' + ids[i + 1]) != null &&
			this.scrollableParent.scrollTop + parentHeight / 2 >=
				this.scrollOffsets[i + 1]
		) {
			i++;
		}
		this.tabIndex = i;
	},
	updateHeight() {
		if (this.cache.root) {
			this.cache.root.style.setProperty(
				'--tab-height',
				this.$el.offsetHeight / 16 + 'rem'
			);
		}
	},
	main: {
		['@scroll.window.throttle.200ms']() {
			this.updateTab();
		},
		['x-init']() {
			this.cache.root = document.querySelector(':root');
			this.scrollableParent = findScrollableParent(
				this.$el.parentElement
			);
			setInterval(() => this.updateOffsets(), 1000);
			this.updateTab();
			if (reportHeight) {
				this.updateHeight();
			}
		},
		['@resize.window.throttle.100ms']() {
			if (reportHeight) {
				this.updateHeight();
			}
		},
	},
});
